import React, { useState, useEffect } from 'react';
import { CircularProgress, Typography } from '@mui/material';
import { getBullBoardUrl } from '../../../api/index.js';

const BullBoardView = () => {
  const [bullBoardUrl, setBullBoardUrl] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUrl = async () => {
      try {
        const url = await getBullBoardUrl();
        setBullBoardUrl(url);
      } catch (error) {
        console.error('Failed to fetch Bull Board URL:', error);
      }
      setLoading(false);
    };

    fetchUrl();
  }, []);

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <div style={{ height: '100vh' }}>
      {bullBoardUrl ? (
        <iframe
          src={bullBoardUrl}
          style={{ width: '100%', height: '100%', border: 'none', paddingTop: '2em' }}
          title="Bull Board"
        />
      ) : (
        <Typography variant="h6" color="error">Failed to load Bull Board URL</Typography>
      )}
    </div>
  );
};

export default BullBoardView;